import FocusableNavItem from '@components/FocusableNavItem';
import { useAuthContext } from '@context/Auth';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { HISTORY, ROOT, SIGN_IN, SIGN_OUT } from '@router/path';
import { useNavigate } from 'react-router-dom';

import * as styles from './style';

const Navigation = () => {
  const { isSignIn } = useAuthContext();

  const { ref, focusKey, hasFocusedChild } = useFocusable({
    focusKey: 'NAV',
    trackChildren: true,
    isNavigation: true
  });

  const navigate = useNavigate();

  const goHome = () => {
    navigate(ROOT);
  };
  const goList = () => {
    navigate(HISTORY);
  };
  const goSignIn = () => {
    navigate(SIGN_IN);
  };
  const goSignOut = () => {
    navigate(SIGN_OUT);
  };

  return (
    <FocusContext.Provider value={focusKey}>
      <div
        css={[
          styles.container,
          hasFocusedChild ? styles.wideContainer : styles.narrowContainer
        ]}
      >
        <div
          css={[
            styles.navContent,
            hasFocusedChild ? styles.navWideContent : styles.navNarrowContent
          ]}
          ref={ref}
        >
          <FocusableNavItem name="home" onEnterPress={goHome} isWide={hasFocusedChild} />
          <FocusableNavItem name="list" onEnterPress={goList} isWide={hasFocusedChild} />
          <FocusableNavItem
            name={isSignIn ? 'sign_out' : 'sign_in'}
            onEnterPress={isSignIn ? goSignOut : goSignIn}
            isWide={hasFocusedChild}
          />
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default Navigation;
